const PERMISSIONS_PRODUCT_MANAGEMENT_PAGE = {
  VIEW: 'kiosk_product::get',
  CREATE: 'kiosk_product::create',
  UPDATE: 'kiosk_product::update',
  DELETE: 'kiosk_product::delete',
  SET_ITEMS: 'kiosk_product::set_items',
  IMPORT: 'kiosk_product::import',
  IMPORT_GET: 'kiosk_product::import.get',
  EXPORT: 'kiosk_product::export',
} as const;

export const PRODUCT_MANAGEMENT_PERMISSIONS = [
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.VIEW,
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.CREATE,
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.UPDATE,
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.DELETE,
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.SET_ITEMS,
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.IMPORT,
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.IMPORT_GET,
  PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.EXPORT,
] as const;

export default PERMISSIONS_PRODUCT_MANAGEMENT_PAGE;
